import { formatDate } from 'utils/common'
import { snStateMap, snOperationMap } from 'utils/map'

export default {
  date (date, format, layout) {
    return formatDate({ date, format, layout })
  },

  snState (state) {
    if (snStateMap.has(state)) {
      return snStateMap.get(state).label
    }
    return '---'
  },

  snOperation (operation) {
    if (snOperationMap.has(operation)) {
      return snOperationMap.get(operation).label
    }
    return '---'
  },

  systemType (type) {
    switch (type) {
      case 1:
        return '太阳能'
      case 2:
        return '市电'
      case 3:
        return '智能开关'
      default:
        return '---'
    }
  },

  iconBoolean (val) {
    return val ? '&#xe673;' : '&#xe67a;'
  },

  snToHex (val) {
    if (Number(val) > 0) {
      return val.toString(16).toLocaleUpperCase()
    } else {
      return (parseInt(val, 10) >>> 0).toString(16).toLocaleUpperCase()
    }
  }
}
